import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import { BlockWrapper } from '../../common/BlockWrapper';
import './Other.scss';
import { CheckDiffText, hasChanges } from '../../common/utils';
import get from 'lodash/get';

const OtherView = ({ originalValue, changedValue }) => (
    <div className='other'>
        <CheckDiffText
            oldValue={originalValue}
            newValue={changedValue}
        />
    </div>
);

const OtherApproval = ({
    changedValue, originalValue, onApprove, onReject, 
}) => (
    <div className="other-block">
        <div className='other'>
            <CheckDiffText
                oldValue={originalValue}
                newValue={changedValue}
            />
        </div>
        <div className="form-actions">
            <RaisedButton
                label="Approve"
                primary
                onClick={() => onApprove('additionalDescription')}
                className="approve-button"
            />
            <RaisedButton
                label="Reject"
                secondary
                onClick={() => onReject('additionalDescription')}
                className="reject-button"
            />
        </div>
    </div>
);

const Other = ({
    port,
    pendingChanges,
    onApproveField,
    onRejectField,
    updatePortField,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [values, setValues] = useState({
        additionalDescription: port.additionalDescription,
    });

    const saveChanges = async (change) => {
        updatePortField('additionalDescription', change, () => {
            setIsEditing(false);
        });
    };

    const processedStatus = get(pendingChanges, 'processedFields.additionalDescription.status');

    const isApproved = processedStatus === 'approved';
    const isRejected = processedStatus === 'rejected';

    const hasOtherChanges = 
        !isApproved &&
        !isRejected &&
        hasChanges(
            get(pendingChanges, 'originalValues.additionalDescription'), 
            get(pendingChanges, 'changedValues.additionalDescription'),
        );

    const cancelEditing = () => {
        setIsEditing(false);
        setValues({
            additionalDescription: port.additionalDescription,
        });
    };

    const enableEdit = () => {
        setIsEditing(true);
        setValues({
            additionalDescription: port.additionalDescription,
        });
    };

    if (hasOtherChanges) {
        return (
            <BlockWrapper title="Other">
                <OtherApproval 
                    originalValue={get(pendingChanges, 'originalValues.additionalDescription')}
                    changedValue={get(pendingChanges, 'changedValues.additionalDescription')}
                    onApprove={onApproveField}
                    onReject={onRejectField}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper title="Other">
            {isEditing ? (
                <div className="other-form">
                    <TextField
                        name="additionalDescription"
                        value={values.additionalDescription || ''}
                        onChange={e => setValues({ ...values, additionalDescription: e.target.value })}
                        floatingLabelText="Other"
                        multiLine
                        fullWidth
                        floatingLabelStyle={{ fontSize: '12px' }}
                    />
                    <div className="form-actions">
                        <RaisedButton
                            label="Save"
                            primary
                            onClick={() => saveChanges(values.additionalDescription)}
                        />
                        <RaisedButton
                            label="Cancel"
                            secondary
                            onClick={cancelEditing}
                        />
                    </div>
                </div>
            ) : (
                <OtherView 
                    originalValue={port.additionalDescription}
                    changedValue={pendingChanges && pendingChanges.changedValues && pendingChanges.changedValues.additionalDescription}
                />
            )}
            <div className="block-buttons">
                {!isEditing && (
                    <RaisedButton
                        label="Edit Other"
                        onClick={enableEdit}
                        primary
                    />
                )}
            </div>
        </BlockWrapper>
    );
};

Other.propTypes = {
    port: PropTypes.shape({
        additionalDescription: PropTypes.string,
    }).isRequired,
    pendingChanges: PropTypes.shape({
        changedValues: PropTypes.shape({
            additionalDescription: PropTypes.string,
        }),
    }),
    onApproveField: PropTypes.func.isRequired,
    onRejectField: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired,
};

export default Other;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Other/Other.jsx